import { GAME_MESSAGE } from 'constant/game'
import { useSelector } from 'react-redux'
import { useCallback } from 'react'
import { CONFIRM_MODAL_TYPE } from 'component/Modal/ConfirmModal'
import { useCustomerServiceModal } from 'component/CustomerServiceModal/provider'
import useConfirmModal from './useConfirmModal'
import { selectGameIpBan } from 'redux/selector/game'
import actions from 'redux/action'

type AccessValidationCallback = () => unknown

interface IpBanCheckResult {
  isIpBan: boolean
  openIpBanModal: () => void
  validateIpBan: (callback?: AccessValidationCallback) => boolean
  updateIsIpBanStatus: (isBanned: boolean) => void
}

export const IP_BAN_ERROR_CODE = 460202

export function useIpBanCheck(): IpBanCheckResult {
  const isIpBan = useSelector((state: boolean) => selectGameIpBan(state))
  const { openConfirm } = useConfirmModal()
  const { openCustomerServiceModal } = useCustomerServiceModal()

  const openIpBanModal = useCallback(() => {
    openConfirm({
      message: GAME_MESSAGE.IP_BAN_NOTICE,
      type: CONFIRM_MODAL_TYPE.OK_CANCEL_CUSTOM,
      cancelText: '联系客服',
      confirmText: '确定',
      onCancel: () => {
        void openCustomerServiceModal()
      },
    })
  }, [openConfirm, openCustomerServiceModal])

  const validateIpBan = useCallback(
    (callback?: AccessValidationCallback) => {
      if (isIpBan === true) {
        openIpBanModal()
        return false
      }

      callback?.()
      return true
    },
    [isIpBan, openIpBanModal]
  )

  const updateIsIpBanStatus = (ban: boolean) => {
    if (ban && isIpBan === false) {
      actions.updateGameIpBan(true)
      openIpBanModal()
    } else if (!ban && isIpBan === true) {
      actions.updateGameIpBan(false)
    }
    // do nothing if the status is the same as before
  }

  return {
    isIpBan,
    openIpBanModal,
    validateIpBan,
    updateIsIpBanStatus,
  }
}
